import { render, staticRenderFns } from "./RbuItemModuleTenderRates.vue?vue&type=template&id=30d360e7"
import script from "./RbuItemModuleTenderRates.vue?vue&type=script&lang=js"
export * from "./RbuItemModuleTenderRates.vue?vue&type=script&lang=js"
import style0 from "./RbuItemModuleTenderRates.vue?vue&type=style&index=0&id=30d360e7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports